import { render, staticRenderFns } from "./videoAnalysis.vue?vue&type=template&id=2ac2406f&scoped=true&"
import script from "./videoAnalysis.vue?vue&type=script&lang=js&"
export * from "./videoAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./videoAnalysis.vue?vue&type=style&index=0&id=2ac2406f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2406f",
  null
  
)

export default component.exports